import { DEFAULT_SERVER_URL } from '../../react/features/base/settings/constants';

export const BASE_API_URL = `${DEFAULT_SERVER_URL}/api`;
export const JIBRI_STATUS_URL = `${BASE_API_URL}/jibri/status`;
